import React from 'react';
import SimeraDashboard from '../../SimeraDashboard/SimeraDashboard';
import InternalDashboardPages from '../../../constants/InternalDashboardPages';

const SimeraDashboardScreenCompany = () => {
  return <SimeraDashboard page={InternalDashboardPages.COMPANY} />;
};

export default SimeraDashboardScreenCompany;
